import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { notification } from "antd";
import PromotionService from "services/PromotionService";
export const initialState = {
  data: [],
  dataDetail: [],
  loading: false,
  error: null,
  redirect: false,
};

export const fetchPromotionData = createAsyncThunk(
  "promotion/fetchPromotionData",
  async (data, { rejectWithValue }) => {
    try {
      const { page, pageSize, sort, searchText, state } = data;
      const response = await PromotionService.get({
        page,
        pageSize,
        sort,
        searchText,
        state,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Error");
    }
  }
);

export const fetchPromotionDetail = createAsyncThunk(
  "promotion/fetchPromotionDetail",
  async (id, { rejectWithValue }) => {
    try {
      const response = await PromotionService.getById(id);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const createPromotionData = createAsyncThunk(
  "promotion/createPromotionData",
  async (data, { rejectWithValue }) => {
    try {
      const {
        discount,
        product,
        expire,
        transaction_type,
        discount_type,
        outlets,
        start_date,
        end_date,
      } = data;
      const response = await PromotionService.createPromotion({
        discount,
        product,
        expire,
        transaction_type,
        discount_type,
        outlets,
        start_date,
        end_date,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const updatePromotionData = createAsyncThunk(
  "promotion/updatePromotionData",
  async (data, { rejectWithValue }) => {
    try {
      const {
        id,
        discount,
        product,
        expire,
        transaction_type,
        discount_type,
        outlets,
        start_date,
        end_date,
      } = data;
      const response = await PromotionService.updatePromotion({
        id,
        discount,
        product,
        expire,
        transaction_type,
        discount_type,
        outlets,
        start_date,
        end_date,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const deletePromotionData = createAsyncThunk(
  "promotion/deletePromotionData",
  async (id, { rejectWithValue }) => {
    try {
      const response = await PromotionService.deletePromotion(id);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

export const promotionSlice = createSlice({
  name: "promotion",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPromotionData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPromotionData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(fetchPromotionData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchPromotionDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPromotionDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.dataDetail = action.payload.data;
        state.error = null;
      })
      .addCase(fetchPromotionDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createPromotionData.pending, (state) => {
        state.loading = true;
        state.redirect = false;
      })
      .addCase(createPromotionData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        state.redirect = true;
        notification.success({ message: "Proses Berhasil" });
      })
      .addCase(createPromotionData.rejected, (state, action) => {
        state.redirect = false;
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updatePromotionData.pending, (state) => {
        state.loading = true;
      })
      .addCase(updatePromotionData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
        notification.success({ message: "Proses Berhasil" });
      })
      .addCase(updatePromotionData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deletePromotionData.pending, (state) => {
        state.redirect = false;
        state.loading = true;
      })
      .addCase(deletePromotionData.fulfilled, (state) => {
        state.loading = false;
        state.redirect = true;
        notification.success({ message: "Proses Berhasil" });
      })
      .addCase(deletePromotionData.rejected, (state, action) => {
        state.redirect = false;
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { showLoading } = promotionSlice.actions;

export default promotionSlice.reducer;
